module.exports = __webpack_public_path__ + "static/img/tx_bg.1ef93fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tx_bg.png
// module id = lKnu
// module chunks = 1